module.exports = __webpack_public_path__ + "img/register.7ae71206.png";